import cookie from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { Sentry } from '~/errorsLogging';

export function useSentrySetUser() {
  const accessToken = cookie.get('accessToken');
  const jwtUser = accessToken && jwtDecode(accessToken);

  useEffect(() => {
    Sentry.setUser({
      id: jwtUser?.sub,
      email: jwtUser?.email,
      ip_address: '{{auto}}',
    });
  }, [jwtUser?.sub, jwtUser?.email]);
}
